export const APP_CONNECT_STATUS = {
  Normal: "Y",
  Failure: "N",
  Unlinked: false,
};

export const LOCAL_STORAGE_KEYS = {
  ACCESS_TOKEN: "ACCESS_TOKEN",
  CEO_INFO: "CEO_INFO",
  PERIODNOTSHOWREVIEWPOPUP: "PeriodNotShowReviewPopup"
};

export const APP_TYPES = {
  Beamin: {
    name: "배민",
    type: "01",
  },
  Yogiyo: {
    name: "요기요",
    type: "02",
  },
  Coupang: {
    name: "쿠팡",
    type: "03",
  },
};

export const RESULT_CODE = {
  UNAUTHORIZE: 'E00003',
  NO_RESULT: "E00005",
  INVALID_REQUEST: "E00006",
  LOGIN_FAIL: 'E01003'
}

export const RESULT_MSG = {
  MAXIMUM_ADDITIONAL: "Maximum 3 additional comments created",
}

export const DATE_FORMAT = {
  YYYYMMDD: "YYYYMMDD",
};

export const CEO_TYPES = {
  NORMAL: "NORMAL",
  PREMIUM: "PREMIUM",
};

export const REVIEW_STATUS_CODE = {
  ALL: {
    name: "모두",
    code: "-1",
  },
  UNANSWERED: {
    name: "미등록",
    code: "00",
  },
  PENDING: {
    name: "등록요청",
    code: "10",
  },
  SUCCESS: {
    name: "등록완료",
    code: "20",
  },
  FAILED: {
    name: "등록실패",
    code: "30",
  },
  EXCLUDED: {
    name: "제외된",
    code: "40",
  },
  EXPIRED: {
    name: "만료됨",
    code: "50",
  },
};


export const PAGE_NO = 1
export const PAGE_SIZE = 10

export const NOTIFICATION_TYPE  = {
  APP_CONNECT_ISSUE: 'APP_CONNECT_ISSUE',
  GETTING_REVIEW_FAILED: 'GETTING_REVIEW_FAILED',
  GETTING_REVIEW_SUCCESS: 'GETTING_REVIEW_SUCCESS',
  MONTHLY_REPORT: 'MONTHLY_REPORT',
  MANUAL: 'MANUAL',
}